import React from "react";
import {FaArrowRight } from "react-icons/fa";
import {FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import FileUpload from "../Components/FileUpload";
import { FaShapes } from "react-icons/fa6";
import { GrNotes } from "react-icons/gr";
import { FaRegClock } from "react-icons/fa6";
import { FaUser } from "react-icons/fa6";
import ProgressBar from 'react-bootstrap/ProgressBar';


const Timeline = () => {

    
     const background ={
     background: '#EEEE',
     padding: '20px',
     paddingBottom: '50px',
   }    

    const now = 75;

    const navigate = useNavigate();

    const handleFileSelect = (file) => {
    console.log("Selected file:", file);
  };

    return(
        <>
            <div className="container mt-5">
                <div className="row">
                    <div className="col-md-4">
                    <div className="nav-option mb-3 option1">
                      <FaShapes className="side" />
                      <p className="" onClick={() => navigate("/start-project")}>Services</p>
                    </div>
                    <div className="nav-option mb-3 option1 active text-decoration-none">
                      <GrNotes className="side" />
                      <p className="" onClick={() => navigate("/project")}>Project Details</p>
                    </div>
                    <div className="nav-option mb-3 option1">
                      <FaRegClock className="side" />
                      <p onClick={() => navigate("/timeline")}>Timeline & Budget</p>
                    </div>
                    <div className="nav-option option1">
                      <FaUser className="side" />
                      <p>Contact Info</p>
                    </div> 
                    <div className="mt-5 mb-5">
                        <h4 style={{color: '#353995', fontWeight: '700'}}>Step 1 of 4</h4>
                        <p>Let’s build  something great.</p>
                        <ProgressBar
                            now={now}
                            label={`${now}%`} 
                            variant="" 
                            >
                            <div
                                style={{
                                width: `${now}%`,
                                backgroundColor: "#F29235",
                                height: "100%",
                                transition: "width 0.6s ease"
                                }}
                            />
                        </ProgressBar>
                    </div>                       
                    </div>
                    <div className="col-md-8" style={background}>
                        <div className="container mt-5">
                            <div className="row top">
                                        <div className="mt-3">
                                            <FileUpload onFileSelect={handleFileSelect} />
                                        </div>
                                        <div className="" onClick={() => navigate("/project")}>
                                            <p style={{color: '#939394', cursor: 'pointer',}}><FaArrowLeft /> Back</p>
                                        <div className="text-end mt-3">
                                            <button className="step" onClick={() => navigate("/")}>Next Step <FaArrowRight /></button>                             
                                        </div>                            
                                        </div>
                                    </div>
                            </div>              
                    </div>                                    
                </div>
                
            </div>

                         
        </>
    )
}

export default Timeline;